import { formatToCurrency } from '../../util/Calculate';
import './style/SummaryFooter.css';
import React from 'react';
import { Text } from '@harperai/materialize-design-system';

// TODO: Minor improvement to make summary fields explicitly defined
const SummaryFooter = ({ summary }) => {
    return (
        <div className="flex horizontal gap-m gap-xl flex-wrap footer-container space-around">
            <div className="flex horizontal gap-m space-around grouped-info">
                <div className="flex vertical align-center" style={{flexShrink: "1"}}>
                    <Text size="title" classes="do-not-break" bold={true}>{summary?.totalShipments?.toString()}</Text>
                    <Text size="caption" variant="secondary" bold={true}  classes="max-content">Shipments</Text>
                </div>
                <div className="flex vertical align-center" style={{flexShrink: "1"}}>
                    <Text size="title" classes="do-not-break" bold={true}>{summary?.totalQuantity?.toString()}</Text>
                    <Text size="caption" variant="secondary" bold={true} classes="max-content">Offer Quantity</Text>
                </div>
            </div>
            <div className="flex horizontal gap-m space-around grouped-info">
                <div className="flex flex-1 vertical align-center" style={{flexShrink: "1"}}>
                    <Text size="title" classes="do-not-break" bold={true}>{formatToCurrency(summary?.unitPrice)}</Text>
                    <Text size="caption" variant="secondary" bold={true} classes="max-content">Avg. Offer Price</Text>
                </div>
                <div className="flex flex-1 vertical align-center" style={{flexShrink: "1"}}>
                    <Text size="title" classes="do-not-break" bold={true}>{formatToCurrency(summary?.totalPrice)}</Text>
                    <Text size="caption" variant="secondary" bold={true}  classes="max-content">Offer Total</Text>
                </div>
            </div>
        </div>
    );
};

export default SummaryFooter;